import { render, staticRenderFns } from "./CreateModelModal.vue?vue&type=template&id=019174d2"
import script from "./CreateModelModal.vue?vue&type=script&lang=js"
export * from "./CreateModelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports